import script from "./RegionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionItem.vue?vue&type=script&setup=true&lang=js"

import "./RegionItem.vue?vue&type=style&index=0&id=76035c5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76035c5b"]])

export default __exports__